export const config = {
  title: "Lilli Greenwood Sprout Realty | Houston, TX Real Estate Services",
  meta: {
    description:
      "Lilli Greenwood Sprout Realty offers comprehensive real estate services in Houston, TX, specializing in buying, selling, and market analysis to exceed client expectations.",
    keywords: [
      'Houston Real Estate',
      'Buy Home Houston',
      'Sell Home Houston',
      'Real Estate Market Analysis',
      'Lilli Greenwood Sprout Realty',
      'Sprout Realty',
      'Texas Real Estate',
      'Home Buying',
      'Home Selling',
      'Property Search'
    ],
    author: "Lilli Greenwood Sprout Realty",
    canonicalUrl: 'https://www.realtyoflillig.com/',
  },
  sections: {
    header: {
      businessName: "Lilli Greenwood Sprout Realty",
    },
    sectionB: {
      heroTitle: "Lilli Greenwood Sprout Realty",
      heroSubtitle: 'Exceeding Your Real Estate Expectations in Houston, TX',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '8322194119',
      phoneLabel: '(832) 219-4119',
      heroBackgroundImage:
        "https://www.spoliamag.com/wp-content/uploads/2021/07/pexels-curtis-adams-5178047-696x521.jpg",
      cardData: [
        {
          title: 'Local Expertise',
          description:
            'In-depth knowledge of Houston communities to find the right home for you.',
        },
        {
          title: 'Selling Your Home',
          description:
            'Comprehensive services from marketing to closing to ensure a smooth sale.',
        },
        {
          title: 'Timing Is Everything',
          description:
            'Providing guidance to make informed decisions whether buying or selling.',
        },
      ],
      description:
        "At Lilli Greenwood Sprout Realty, we bring a wealth of knowledge on local communities, current market conditions, and the home buying and selling process. We strive to provide exceptional service every step of the way, ensuring a real estate experience that exceeds your expectations.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover the range of real estate services we offer to meet your needs.",
      cards: [
        {
          title: 'Home Buying Assistance',
          description:
            'Guiding you through the process to find and purchase your ideal home in Houston.',
          imageSrc:
            'https://media.istockphoto.com/id/1696692507/photo/real-estate-agents-insurance-sales-agents-and-young-asian-businessmen-handing-home-keys-and.jpg?s=612x612&w=0&k=20&c=yTFfwyKXFE82WVYjm2mDfKEorDVbhvJ6cVqmsvoF2hs=',
          imageAlt: 'Home Buying Assistance',
        },
        {
          title: 'Home Selling Strategies',
          description:
            'Expert marketing and negotiation to sell your home at the best price.',
          imageSrc:
            'https://media.istockphoto.com/id/1404294064/photo/three-business-people-meeting-and-looking-at-a-laptop-and-a-document.jpg?s=612x612&w=0&k=20&c=43CBb0LT46DrQ41hOFKQzky4pK7JpiElRC6KLek8gVk=',
          imageAlt: 'Home Selling Strategies',
        },
        {
          title: 'Market Analysis',
          description:
            'Providing detailed market insights to help you make informed decisions.',
          imageSrc:
            'https://media.istockphoto.com/id/1347890599/photo/asian-businessman-checking-stock-market-chart-on-digital-tablet.jpg?s=612x612&w=0&k=20&c=N-36jontlCM0rpK4aHup-2UbHVhmj9njV1u9F4Bd2v0=',
          imageAlt: 'Market Analysis',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Property Valuation',
        'Neighborhood Insights',
        'Investment Property Guidance',
        'Relocation Assistance',
        'Real Estate Consultation'
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://images.marketleader.com/MarketingImages/87/2404387_normal.PNG',
        alt: "Lilli Greenwood Sprout Realty Team",
      },
      aboutText: [
        "Exceeding Your Expectations",
        "At Lilli Greenwood Sprout Realty, we bring a wealth of knowledge on local communities, current market conditions, and the home buying and selling process. We strive to provide exceptional service every step of the way, ensuring a real estate experience that exceeds your expectations.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Lilli Greenwood",
      businessName: "Lilli Greenwood Sprout Realty",
      contact: {
        phone: '8322194119',
        phoneLabel: '(832) 219-4119',
        email: 'lilli@sprouthomes.com',
        website: 'https://www.realtyoflillig.com/',
        address: 'Houston, TX 77007, USA',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Houston, TX 77007, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3437.0000000000005!2d-95.40000000000001!3d29.760000000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640b8b000000000%3A0x0000000000000000!2sHouston%2C%20TX%2077007%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
